// T45 + BUSINESS-100 (25 Okt 2026) — fungsi murni status WhatsApp ke customer (tanpa impor komponen, bisa diuji jest).

export const PERAN_STATUS_WA = ["OWNER", "KEPALA_CABANG", "CS"];

/** '0813-4707-0880' / '+62 813…' / '62813…' / '813…' → '62813…' — cermin `pagar_kirim_keluar.normal_nomor`. */
export function normalNomor(n) {
  let d = String(n || "").replace(/\D/g, "");
  if (d.startsWith("0")) d = "62" + d.slice(1);
  else if (d.startsWith("8")) d = "62" + d;
  return d;
}

const LABEL_BERMASALAH = { NOMOR_SALAH: "nomor salah", NOMOR_TIDAK_AKTIF: "nomor tidak aktif" };

/** BUSINESS-100: tanda nomor WhatsApp bermasalah — hanya selama nomor customer MASIH nomor yang ditandai. */
export function nomorBermasalah(cust) {
  if (!cust || !cust.wa_bermasalah || !cust.wa_bermasalah_nomor) return null;
  if (normalNomor(cust.phone) !== cust.wa_bermasalah_nomor) return null;
  return { label: LABEL_BERMASALAH[cust.wa_bermasalah] || "nomor bermasalah", pada: cust.wa_bermasalah_pada };
}

/** T62 (26 Okt 2026): siapa & pesanan apa — "Nama · PDBPN-2610-0001 · 081347070880". Kosong bila server tidak
 *  mengirimnya. */
export function rujukanStatusWa(x) {
  return [x?.customer?.nama, x?.nomor_pesanan, x?.nomor].filter(Boolean).join(" · ");
}

/** T62: hasil tugas CS di daftar status — "sudah dihubungi oleh Rina, <waktu>" sesudah dicatat, bukan tetap
 *  "menunggu ditangani CS". `fmt` = pemformat waktu (layar memakai formatDateTime). null bila pesan bukan tugas. */
export function teksTugasWa(item, fmt = (s) => s) {
  if (!item || !item.tugas) return null;
  // T77 (titipan auditor 27 Okt 2026): pesan yang akhirnya sampai sesudah jadi tugas = tugas selesai sendiri,
  // supaya CS tidak menghubungi customer yang sudah menerima. Hasil yang dicatat CS tetap menang.
  if (!item.tugas.hasil && item.tugas.selesai_sendiri) {
    const t = item.tugas.selesai_sendiri;
    return t && t !== "?" ? `selesai sendiri — sudah sampai ${fmt(t)}` : "selesai sendiri — sudah sampai";
  }
  if (!item.tugas.hasil) return "menunggu ditangani CS";
  const dasar = item.tindak_lanjut_teks || `CS: ${item.tugas.hasil_label || "sudah ditangani"}`;
  return item.tugas.dicatat ? `${dasar}, ${fmt(item.tugas.dicatat)}` : dasar;
}
